import styles from "./TeacherCard.module.css";
import { ArrowIcon } from "./ArrowIcon";



{/* <TeacherCard
  img="https://cdn.mytakbir.com/static-assets/teachers/prof-khaleel-ul-rahman-chishti.png"
  name="MUNA Academy"
  button={true}
  buttonlebel="View teaching page"
//link={item.link}
/> */}

function TeacherCard(props) {


  return (
    <div className={styles.Card}>
      <img
        className={styles.CardImg}
        src={props.img}
        alt={props.name}
      />
      <div className={styles.CardDetails}>
        <div className={styles.CardDetailsInner}>
          <div className={styles.CardTitle}>{props.name}</div>
          {props.button &&
            <div className={styles.CardButton}>
              <a href={props.link}>
                {props.buttonlebel}
                <ArrowIcon />
              </a>
            </div>
          }
        </div>
      </div>
    </div>
  );
}

export default TeacherCard;
